import styled, { css } from 'styled-components';
import { typography } from 'styled-system';
import { getBackgroundColor, getMediaQuery, getTextColor, themeGet } from '@magalu/stereo-ui-styles';
import Text from '../../../atoms/Text';
import Heading from '../../../atoms/Heading';
import Image from '../../../atoms/ResponsiveImage';
const wrapperMarginRight = 28;
export const Wrapper = styled.a`
  text-decoration: none;
  cursor: pointer;
  ${props => props.hide && 'display: none;'}
  ${getMediaQuery('medium')} {
    width: calc(25% - ${wrapperMarginRight / 4}px);
    &:not(:last-child) {
      margin-right: ${wrapperMarginRight}px;
    }
  }
`;
export const Content = styled.article`
  background-color: ${props => getBackgroundColor('lighter')(props)};
  border-top: 1px solid ${props => getBackgroundColor('darker')(props)};
  display: grid;
  padding: 16px;
  width: 100%;
  ${({
  vertical
}) => !vertical && `grid-template-columns: auto 1fr;`}
  ${({
  vertical
}) => vertical && css`
      justify-items: left;
      padding: 16px 0px;
    `}
`;
export const ImageContainer = styled.div`
  width: 100%;
  ${({
  vertical
}) => !vertical && `margin-right: 20px;`}
`;
export const ImageItem = styled(Image)`
  width: 77px;
  border-radius: 4px;
  border: 1px solid ${props => getTextColor('lighter')(props)};

  ${({
  cover
}) => cover && css`
      object-fit: cover;
      height: 77px;
    `}

  ${({
  vertical
}) => vertical && css`
      min-width: 300px;
      width: 100%;
      height: auto;
      max-height: 500px;
      object-fit: fill;

      ${getMediaQuery('medium')} {
        max-height: 500px;
        min-height: 168px;
        min-width: 224px;
        height: calc(
          900px /
            ${({
  variation,
  itemsSize
}) => variation === 'horizontal-highlight' ? itemsSize : 4}
        );
        border-radius: 8px;
        object-fit: cover;
      }
    `}
`;
const ArticleContentVertical = css`
  margin-top: 10px;
  width: 250px;

  ${getMediaQuery('large')} {
    max-width: 224px;
  }
`;
export const ArticleContent = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  margin-top: ${({
  cover
}) => cover ? '8px' : '0px'};
  ${({
  vertical
}) => vertical && ArticleContentVertical}
`;
export const TextContainer = styled.div``;
export const Title = styled(Heading).attrs(() => ({
  fontSize: [1, 1, 3, 3]
}))`
  color: ${props => getTextColor('luContentLink')(props)};
  font-weight: ${props => themeGet('fontWeights.medium')(props)};
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;
export const Description = styled(Text).attrs(() => ({
  fontSize: [0, 0, 1, 1]
}))`
  margin-top: 8px;
  color: ${props => getTextColor('base')(props)};
  line-height: ${props => themeGet('lineHeights.plus')(props)}px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  ${typography}
`;